export default __webpack_public_path__ + "static/128-402edfffbdf6d03b5b4c5ada2e11c9f6.gif";